import React, { Component } from 'react';
import IconButton from '@material-ui/core/IconButton';
import AppsIcon from '@material-ui/icons/Apps';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: "transparent",
        color: "inherit",
        width: "48px",
        height: "48px",
    }
}));

const ButtonLogin = ({onClick, forwardedRef}) => {

    const classes = useStyles()

    return (
        <IconButton className={classes.root} onClick={onClick} ref={forwardedRef} >
            <AppsIcon />
        </IconButton>
    )

}

export default ButtonLogin;